import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Home, ArrowLeft, Search } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleSearch = () => {
    // You can redirect to a search page or implement search functionality
    navigate('/dashboard');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="mx-auto w-24 h-24 bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <span className="text-4xl font-bold text-blue-600">404</span>
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">
            Page Not Found
          </CardTitle>
          <CardDescription className="text-gray-600">
            The page you're looking for doesn't exist or has been moved.
          </CardDescription>
        </CardHeader>

        <CardContent className="space-y-4">
          <div className="bg-gray-100 rounded-lg p-4">
            <h4 className="font-semibold text-sm text-gray-900 mb-2">Possible reasons:</h4>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• The URL might be misspelled</li>
              <li>• The page might have been removed or relocated</li>
              <li>• You might not have access to this page</li>
              <li>• The link you followed might be broken</li>
            </ul>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <h4 className="font-semibold text-sm text-blue-900 mb-2">Helpful suggestions:</h4>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• Check the URL for typos</li>
              <li>• Use the navigation menu to find what you need</li>
              <li>• Go back to the previous page</li>
              <li>• Return to the dashboard</li>
            </ul>
          </div>
        </CardContent>

        <CardFooter className="flex flex-col gap-3">
          <div className="flex gap-3 w-full">
            <Button onClick={handleGoBack} variant="outline" className="flex-1 flex items-center gap-2">
              <ArrowLeft className="w-4 h-4" />
              Go Back
            </Button>
            <Button onClick={handleGoHome} className="flex-1 flex items-center gap-2">
              <Home className="w-4 h-4" />
              Dashboard
            </Button>
          </div>
          <Button onClick={handleSearch} variant="secondary" className="w-full flex items-center gap-2">
            <Search className="w-4 h-4" />
            Browse Navigation
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default NotFoundPage;